import axios from 'axios'
import router from '../../router'

const actions = {
  apiInformantPostsComment (context, payload) {
    axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
    axios.post('/api/informant/posts/' + payload.postId + '/comment', payload)
      .then((response) => {
        context.commit('setAddComments', response.data)
        alert('댓글이 등록되었습니다.')
      })
      .catch((error) => {
        alert(error.response.data.message)
        if (error.response.status === 410) {
          sessionStorage.removeItem('token')
          router.push('/reportinquiry')
        }
      })
  },
  apiAdminPostsComment (context, payload) {
    axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
    if (payload.method === 'PATCH') {
      axios.patch('/api/admin/posts/' + payload.commentId + '/comment', payload)
        .then((response) => {
          context.dispatch('apiAdminInquiry')
          alert('댓글이 수정되었습니다.')
        })
        .catch((error) => {
          alert(error.response.data.message)
          if (error.response.status === 410) {
            sessionStorage.removeItem('token')
            router.push('/sessiontimeout')
          }
        })
    } else {
      axios.post('/api/admin/posts/' + payload.postId + '/comment', payload)
        .then((response) => {
          context.commit('setAdminAddComments', response.data)
          context.dispatch('apiAdminInquiry')
          alert('댓글이 등록되었습니다.')
        })
        .catch((error) => {
          alert(error.response.data.message)
          if (error.response.status === 410) {
            sessionStorage.removeItem('token')
            router.push('/sessiontimeout')
          }
        })
    }
  }
}
export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/comment.js